const IconCanvas = ({ type, children }) => (
    <svg
        className={`pricing-feature-icon-art is-${type}`}
        viewBox="0 0 120 120"
        aria-hidden="true"
        focusable="false"
    >
        {children}
    </svg>
);

const commonStroke = {
    fill: "none",
    stroke: "#172b24",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
};

const PricingFeatureIllustration = ({ type }) => {
    switch (type) {
        case "score":
            return (
                <IconCanvas type={type}>
                    <rect width="120" height="120" rx="26" fill="#d9f2e5" />
                    <circle cx="96" cy="24" r="14" fill="#c9f36a" />
                    <g className="pricing-icon-primary" {...commonStroke}>
                        <path d="M37 23v10M83 23v10" />
                        <rect x="18" y="31" width="84" height="63" rx="10" fill="#fff" />
                        <path d="M18 46h84M60 46v48" />
                        <path d="M43 94l-5 8M77 94l5 8" />
                    </g>
                    <g fill="#172b24" fontSize="24" fontWeight="900" textAnchor="middle">
                        <text x="39" y="76">42</text><text x="81" y="76">31</text>
                    </g>
                    <rect x="45" y="82" width="30" height="5" rx="2.5" fill="#c9f36a" />
                    <circle className="pricing-icon-pulse" cx="27" cy="39" r="3" fill="#22a06b" />
                </IconCanvas>
            );

        case "tournaments":
            return (
                <IconCanvas type={type}>
                    <rect width="120" height="120" rx="26" fill="#fff1ce" />
                    <circle cx="97" cy="24" r="14" fill="#ffca63" />
                    <rect x="18" y="18" width="84" height="84" rx="20" fill="#fff" />
                    <g className="pricing-icon-primary" {...commonStroke}>
                        <path d="M39 29h42v20c0 17-8 27-21 27s-21-10-21-27z" fill="#c9f36a" />
                        <path d="M39 36h-9v7c0 10 5 17 14 18M81 36h9v7c0 10-5 17-14 18" />
                        <path d="M60 76v10M49 87h22M43 94h34" />
                    </g>
                    <path
                        d="M60 39l2.3 4.8 5.2.7-3.8 3.7.9 5.2-4.6-2.5-4.6 2.5.9-5.2-3.8-3.7 5.2-.7z"
                        fill="#fff1ce"
                        stroke="#172b24"
                        strokeWidth="2.4"
                        strokeLinejoin="round"
                    />
                </IconCanvas>
            );

        case "queues":
            return (
                <IconCanvas type={type}>
                    <rect width="120" height="120" rx="26" fill="#e9e2ff" />
                    <circle cx="94" cy="24" r="14" fill="#c9bdf3" />
                    <g className="pricing-icon-primary" {...commonStroke}>
                        <rect x="18" y="24" width="78" height="73" rx="11" fill="#fff" />
                        <path d="M28 49h58M28 72h47" stroke="#d8d0f6" />
                        <circle cx="35" cy="37" r="8" fill="#e9e2ff" />
                        <circle cx="35" cy="60" r="8" fill="#e9e2ff" />
                        <circle cx="35" cy="83" r="8" fill="#e9e2ff" />
                        <path d="M51 37h31M51 60h25M51 83h15" />
                        <circle cx="89" cy="84" r="18" fill="#c9f36a" />
                        <path d="M89 74v11l7 4" />
                    </g>
                    <g fill="#172b24" fontSize="8" fontWeight="900" textAnchor="middle">
                        <text x="35" y="40">1</text><text x="35" y="63">2</text><text x="35" y="86">3</text>
                    </g>
                </IconCanvas>
            );

        case "streaming":
            return (
                <IconCanvas type={type}>
                    <rect width="120" height="120" rx="26" fill="#dfeeff" />
                    <circle cx="25" cy="92" r="14" fill="#9bc7ff" />
                    <g className="pricing-icon-primary" {...commonStroke}>
                        <rect x="18" y="38" width="67" height="51" rx="11" fill="#fff" />
                        <path d="M85 53l18-10v41L85 74z" fill="#c9f36a" />
                        <path className="pricing-icon-play" d="M43 51l20 12-20 12z" fill="#c9f36a" />
                    </g>
                    <g className="pricing-icon-signal" {...commonStroke} strokeWidth="3">
                        <path d="M72 29c7-6 15-6 22 0M78 36c4-3 8-3 12 0" />
                    </g>
                    <rect x="24" y="25" width="34" height="17" rx="8.5" fill="#172b24" />
                    <circle className="pricing-icon-pulse" cx="33" cy="33.5" r="3" fill="#ff6b57" />
                    <text x="45" y="36" fill="#fff" fontSize="7" fontWeight="900" textAnchor="middle">LIVE</text>
                </IconCanvas>
            );

        case "stats":
            return (
                <IconCanvas type={type}>
                    <rect width="120" height="120" rx="26" fill="#d9f2e5" />
                    <circle cx="28" cy="28" r="13" fill="#c9f36a" />
                    <g className="pricing-icon-primary" {...commonStroke}>
                        <path d="M25 91h74" />
                        <rect x="30" y="66" width="12" height="25" rx="3" fill="#fff" />
                        <rect x="53" y="52" width="12" height="39" rx="3" fill="#fff" />
                        <rect x="76" y="38" width="12" height="53" rx="3" fill="#c9f36a" />
                        <path className="pricing-icon-trend" d="M28 57l21-18 18 8 27-25" />
                        <path d="M84 22h10v10" />
                    </g>
                </IconCanvas>
            );

        case "unlimited":
            return (
                <IconCanvas type={type}>
                    <rect width="120" height="120" rx="26" fill="#fff1ce" />
                    <circle cx="60" cy="60" r="43" fill="#fff" />
                    <g className="pricing-icon-primary" {...commonStroke}>
                        <path
                            d="M20 60c11-24 27-24 40 0s29 24 40 0c-11-24-27-24-40 0S31 84 20 60"
                            strokeWidth="14"
                        />
                        <path
                            className="pricing-icon-infinity"
                            d="M20 60c11-24 27-24 40 0s29 24 40 0c-11-24-27-24-40 0S31 84 20 60"
                            stroke="#c9f36a"
                            strokeWidth="7"
                        />
                    </g>
                    <circle cx="93" cy="25" r="10" fill="#ffca63" />
                    <path d="M88 25h10M93 20v10" fill="none" stroke="#172b24" strokeWidth="3" strokeLinecap="round" />
                </IconCanvas>
            );

        case "pairing":
            return (
                <IconCanvas type={type}>
                    <rect width="120" height="120" rx="26" fill="#e9e2ff" />
                    <circle cx="28" cy="92" r="14" fill="#c9bdf3" />
                    <g className="pricing-icon-primary" {...commonStroke}>
                        <rect x="16" y="31" width="63" height="48" rx="7" fill="#fff" />
                        <path d="M31 90h34M40 79l-4 11M59 79l4 11" />
                        <rect x="73" y="50" width="30" height="51" rx="8" fill="#c9f36a" />
                        <path d="M82 76l6 6 10-13" />
                    </g>
                    <g className="pricing-icon-signal" {...commonStroke} strokeWidth="3">
                        <path d="M71 31c10-8 20-8 30 0M77 40c6-5 12-5 18 0" />
                    </g>
                </IconCanvas>
            );

        case "players":
            return (
                <IconCanvas type={type}>
                    <rect width="120" height="120" rx="26" fill="#dfeeff" />
                    <circle cx="96" cy="28" r="15" fill="#9bc7ff" />
                    <g className="pricing-icon-primary" {...commonStroke}>
                        <circle cx="49" cy="43" r="14" fill="#c9f36a" />
                        <path d="M22 93c2-23 15-33 27-33s25 10 27 33z" fill="#fff" />
                        <circle cx="82" cy="61" r="10" fill="#fff" />
                        <path d="M75 91c1-13 8-20 17-20 8 0 14 5 16 16" />
                    </g>
                    <path d="M88 23l4 4 8-9" fill="none" stroke="#172b24" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </IconCanvas>
            );

        default:
            return (
                <IconCanvas type="updates">
                    <rect width="120" height="120" rx="26" fill="#d9f2e5" />
                    <circle cx="27" cy="92" r="15" fill="#c9f36a" />
                    <g className="pricing-icon-primary" {...commonStroke}>
                        <rect x="19" y="23" width="82" height="70" rx="11" fill="#fff" />
                        <path d="M19 39h82" />
                        <circle cx="28" cy="31" r="2" fill="#ff8b78" stroke="none" />
                        <circle cx="36" cy="31" r="2" fill="#ffca63" stroke="none" />
                        <circle cx="44" cy="31" r="2" fill="#7fd6b0" stroke="none" />
                        <path d="M60 49v24M51 65l9 9 9-9" />
                        <path d="M43 82h34" />
                    </g>
                    <circle cx="91" cy="84" r="14" fill="#172b24" />
                    <path d="M84 84l5 5 9-11" fill="none" stroke="#c9f36a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path className="pricing-icon-spark" d="M96 18l2.5 7 7 2.5-7 2.5-2.5 7-2.5-7-7-2.5 7-2.5z" fill="#22a06b" />
                </IconCanvas>
            );
    }
};

export default PricingFeatureIllustration;
